import { useEffect, useRef } from "react";
import { Button } from "./Button";

const AUTO_DISMISS_MS = 4000;

export function Toast({
  text,
  actionLabel,
  onAction,
  onDismiss,
}: {
  text: string | null;
  actionLabel?: string;
  onAction?: () => void;
  onDismiss?: () => void;
}) {
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (!text) return;
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      onDismiss?.();
      timerRef.current = null;
    }, AUTO_DISMISS_MS) as unknown as number;
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
      timerRef.current = null;
    };
  }, [text, onDismiss]);

  if (!text) return null;

  return (
    <div className="fixed bottom-24 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-md border border-border bg-card px-4 py-2 text-sm shadow-elevated dark:border-border-dark dark:bg-card-dark md:bottom-10">
      <span>{text}</span>
      {actionLabel && (
        <Button
          size="sm"
          variant="outline"
          onClick={() => {
            if (timerRef.current) {
              window.clearTimeout(timerRef.current);
              timerRef.current = null;
            }
            onAction?.();
          }}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
